class SacredElements extends HTMLElement {
  connectedCallback() {
    var chapter = this.closest('.pb-sacred-elements-chapter');
    this.mobileDetails = chapter ? Array.prototype.slice.call(
      chapter.querySelectorAll('.pb-sacred-elements-mobile__item[data-sacred-block-id]')
    ) : [];

    if (this.dataset.sacredEnhanced === 'true') return;

    this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.dataset.sacredEnhanced = 'true';
    this.selectedIndex = this.tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });
    if (this.selectedIndex < 0) this.selectedIndex = 0;

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        this.select(index);
      }.bind(this));
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 :
          (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + this.tabs.length) % this.tabs.length;

        this.select(next);
        this.tabs[next].focus();
      }.bind(this));
    }, this);

    this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
    this.select(this.selectedIndex);
  }

  handleBlockSelect(event) {
    var source = event.target;
    if (source && typeof source.closest === 'function') {
      source = source.closest('[data-sacred-block-id]') || source;
    }

    var blockId = source && source.dataset ? source.dataset.sacredBlockId : '';
    if (!blockId && event.detail) blockId = event.detail.blockId || event.detail.block_id;
    if (!blockId) return;

    blockId = String(blockId);
    var index = this.tabs.findIndex(function (tab) {
      return tab.dataset.sacredBlockId === blockId;
    });
    if (index < 0) return;

    this.select(index);
    this.mobileDetails.forEach(function (details) {
      details.open = details.dataset.sacredBlockId === blockId;
    });
  }

  select(index) {
    if (!Number.isInteger(index) || index < 0 || index >= this.tabs.length) return;

    this.selectedIndex = index;
    this.tabs.forEach(function (tab, current) {
      var selected = current === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.panels[current].hidden = !selected;
    }, this);
  }
}

if (!customElements.get('sacred-elements')) {
  customElements.define('sacred-elements', SacredElements);
}
